import { formatMillions } from '../ceoFormat';
import {
  KpiBox,
  KpiGrid,
  KpiLabel,
  KpiSub,
  KpiSuccessStrong,
  KpiSuccessValue,
  KpiValue,
  KpiWarningValue,
} from './styles';

interface ApprovalsKpiGridProps {
  availableCashStart: number;
  pendingApprovalsTotal: number;
  pendingCriticalTotal: number;
  approvedTodayTotal: number;
  deferredTodayTotal: number;
  projectedCashAfterApproved: number;
  projectedCashAfterAllPending: number;
}

export function ApprovalsKpiGrid({
  availableCashStart,
  pendingApprovalsTotal,
  pendingCriticalTotal,
  approvedTodayTotal,
  deferredTodayTotal,
  projectedCashAfterApproved,
  projectedCashAfterAllPending,
}: ApprovalsKpiGridProps) {
  return (
    <KpiGrid>
      <KpiBox>
        <KpiLabel>Свободный остаток на утро</KpiLabel>
        <KpiValue>{formatMillions(availableCashStart)}</KpiValue>
        <KpiSub>Расчётные счета + овернайт + доступный овердрафт</KpiSub>
      </KpiBox>
      <KpiBox>
        <KpiLabel>Ожидают акцепта Гендиректора</KpiLabel>
        <KpiWarningValue>{formatMillions(pendingApprovalsTotal)}</KpiWarningValue>
        <KpiSub>В т.ч. критичные/высокие: {formatMillions(pendingCriticalTotal)}</KpiSub>
      </KpiBox>
      <KpiBox>
        <KpiLabel>Уже акцептовано сегодня</KpiLabel>
        <KpiSuccessValue>{formatMillions(approvedTodayTotal)}</KpiSuccessValue>
        <KpiSub>Отложено: {formatMillions(deferredTodayTotal)}</KpiSub>
      </KpiBox>
      <KpiBox>
        <KpiLabel>Прогноз остатка после оплат</KpiLabel>
        <KpiValue>{formatMillions(projectedCashAfterApproved)}</KpiValue>
        <KpiSub>
          При акцепте всех ожидающих:{' '}
          <KpiSuccessStrong>{formatMillions(projectedCashAfterAllPending)}</KpiSuccessStrong>
        </KpiSub>
      </KpiBox>
    </KpiGrid>
  );
}
